import AbmMails from "../../components/textos/AbmMails/AbmMails";

export const configTable = {
    urls: [
        "/Texto/GetByIdTipoTexto/16?Pagina=1&RegistrosPorPagina=-1", // GET
        "/Texto", // POST 
        "/Texto", // PUT
        "/Texto" // DELETE
    ],
    grid: {
        columnConfig: ["id","nombre", "descripcion"], 
        searchField: ["nombre", "id", "descripcion"]
    },
    Abm: AbmMails,
    textSize: 10
}